import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'role',
    serviceName: 'shopadmin',
    query: gql`
      query role($ids: [String]) {
        role(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
